// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.readOnlyQuestion {
  padding: 14px 22px;
  position: relative;
}
.readOnlyQuestion .topRow {
  display: flex;
}
.readOnlyQuestion .topRow .questionNumber {
  display: inline-block;
  width: 12px;
  margin-right: 8px;
  font-size: 20px;
  color: rgba(38, 38, 38, 0.3);
}
.readOnlyQuestion .topRow .questionText {
  display: inline-block;
  margin-right: 25px;
  color: #262626;
  opacity: 0.6;
}
.readOnlyQuestion .topRow .iconButton {
  border: none;
  position: absolute;
  top: 14px;
  right: 22px;
}
.readOnlyQuestion .answer,
.readOnlyQuestion .seeMoreText {
  margin-left: 20px;
}
.readOnlyQuestion .answer {
  margin-top: 5px;
  font-size: 15px;
  line-height: 20px;
  color: #262626;
}
.readOnlyQuestion .seeMoreText {
  display: inline-block;
  margin-top: 10px;
  color: #19419b;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/refereeReview/ReadOnlyQuestion.less"],"names":[],"mappings":"AAEA;EAMC,kBAAA;EACA,kBAAA;AAND;AADA;EAUE,aAAA;AANF;AAJA;EAaG,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;AANH;AAXA;EAqBG,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAPH;AAjBA;EA4BG,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AARH;AAvBA;;EAqCE,iBAAA;AAVF;AA3BA;EAyCE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXF;AAjCA;EAgDE,qBAAA;EACA,gBAAA;EACA,cAAA;AAZF","sourcesContent":["@import (reference) '../../constants.less';\n\n.readOnlyQuestion {\n\t@questionNumberWidth: 12px;\n\t@questionNumberMarginRight: 8px;\n\t@questionPadddingVertical: 14px;\n\t@questionPadddingHorizontal: 22px;\n\n\tpadding: @questionPadddingVertical @questionPadddingHorizontal;\n\tposition: relative;\n\n\t.topRow {\n\t\tdisplay: flex;\n\n\t\t.questionNumber {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: @questionNumberWidth;\n\t\t\tmargin-right: @questionNumberMarginRight;\n\t\t\tfont-size: 20px;\n\t\t\tcolor: rgba(38, 38, 38, 0.3);\n\t\t}\n\n\t\t.questionText {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 25px;\n\t\t\tcolor: @grey26;\n\t\t\topacity: 0.6;\n\t\t}\n\n\t\t.iconButton {\n\t\t\tborder: none;\n\t\t\tposition: absolute;\n\t\t\ttop: @questionPadddingVertical;\n\t\t\tright: @questionPadddingHorizontal;\n\t\t}\n\t}\n\n\t.answer,\n\t.seeMoreText {\n\t\tmargin-left: (@questionNumberWidth + @questionNumberMarginRight);\n\t}\n\n\t.answer {\n\t\tmargin-top: 5px;\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t\tcolor: @grey26;\n\t}\n\n\t.seeMoreText {\n\t\tdisplay: inline-block;\n\t\tmargin-top: 10px;\n\t\tcolor: @linkBlue;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
